exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#address-header {\n  padding-bottom: 1em;\n}\n#address-details {\n  margin-bottom: 2em;\n}\n#address-details .column:last-of-type {\n    margin-left: 0.5em;\n}\n#address-verifier h5 {\n  margin-top: 1em;\n}\n", "", {"version":3,"sources":["/home/runner/work/online-store/online-store/src/components/orders/initial-order-setup/AddressVerifier.vue"],"names":[],"mappings":";AAAA;EACE,oBAAoB;CAAE;AAExB;EACE,mBAAmB;CAAE;AACrB;IACE,mBAAmB;CAAE;AAEzB;EACE,gBAAgB;CAAE","file":"AddressVerifier.vue","sourcesContent":["#address-header {\n  padding-bottom: 1em; }\n\n#address-details {\n  margin-bottom: 2em; }\n  #address-details .column:last-of-type {\n    margin-left: 0.5em; }\n\n#address-verifier h5 {\n  margin-top: 1em; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-345223d6","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/orders/initial-order-setup/AddressVerifier.vue
// module id = Pakd
// module chunks = 18